<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "app",
  created() {
    this.ACT_PUBLIC_KEY();
  },
  methods: {
    ...mapActions(["ACT_PUBLIC_KEY"]),
  },
};
</script>
